module.exports = __webpack_public_path__ + "img/343.5b8bb1e4.jpg";